import { useEffect, useState, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import axiosAdmin from "../../../../api/apiAdmin";
import { successToast, errorToast } from "../../toastAlerts/ToastAlerts";
import { TextInput } from "../../inputComponents/inputcomp";
import { PrimaryContext } from "../../../../components/MainContext/MainContext";
import { useTranslation } from "react-i18next";

//images
import logo from "../../../img/phoneLogo.png";
import { AdminPrimaryContext } from "../../adminContext/AdminContext";
import { apiError } from "../../../../api/apiError";

const InnerUsPage = () => {
  const { t } = useTranslation();
  //get current user id
  const { siteUsersId } = useParams();
  //new Users data
  const [usersData, setUsersData] = useState({});
  //error
  const [error, setError] = useState(null);
  //data from context
  const { setIsAuthorized, setUser, setToken } = useContext(PrimaryContext);
  //admin context data
  const { user } = useContext(AdminPrimaryContext);

  //handle new Users
  const handleNewUsersData = (value, inputName) => {
    setUsersData((prev) => ({ ...prev, [inputName]: value }));
  };

  // access user
  const handleAccessUser = async (id) => {
    try {
      const res = await axiosAdmin.get(`/user/${id}`);
      if (res) {
        setUser(res.data.user);
        setToken(res.data.token);
        window.open("https://mglparcel.com", "_blank");
      }
    } catch (error) {}
  };

  // blacklist/unblacklist user
  const handleBlacklist = async () => {
    try {
      const res = await axiosAdmin.get(`/user/blacklist/${siteUsersId}`);
      if (res) {
        setUsersData((prev) => ({
          ...prev,
          status: prev.status === 0 ? 1 : 0,
        }));
        successToast(t("admin_data_updated"));
      }
    } catch (error) {
      errorToast(apiError(error, t("admin_error")));
    }
  };

  //add new Users
  const handleEditUsers = async () => {
    try {
      const res = await axiosAdmin.put(`/users/${siteUsersId}`, {
        ...usersData,
        balance: parseFloat(usersData.balance),
      });
      if (res) {
        successToast(t("admin_data_updated"));
      }
    } catch (error) {
      setError(error);
      errorToast(apiError(error, t("admin_error")));
    }
  };

  //Users data from api
  useEffect(() => {
    try {
      axiosAdmin.get(`/users/${siteUsersId}`).then(({ data }) => {
        setUsersData(data);
      });
    } catch (error) {
      setError(error);
    }
  }, []);

  return (
    <div
      className="xl:ml-[280px] mt-[55px] bg-slate-100 dark:bg-slate-900 
            min-h-screen p-10 sm:p-5 pb-24 sm:pb-24"
    >
      <div className="sm:px-0">
        <div className="w-full rounded-xl bg-white dark:bg-slate-700 p-5">
          <div className="flex items-center justify-between flex-wrap gap-5">
            <div className="flex items-center gap-5 sm:gap-3">
              <div className="w-[100px] h-10">
                <img src={logo} className="w-full h-full" />
              </div>
              <div>
                <h2
                  className="text-xl text-slate-600 font-bold dark:text-gray-400
                                sm:text-[16px] smd:text-[16px]"
                >
                  {t("admin_edit_user_info")}
                </h2>
              </div>
            </div>
            <div className="flex gap-1 items-center">
              <button
                onClick={handleEditUsers}
                className="rounded-lg p-3 text-white text-sm bg-violet-400 sm:w-full"
              >
                {t("admin_save")}
              </button>
              <button
                onClick={handleBlacklist}
                className={`rounded-lg p-3 text-white text-sm sm:w-full ${
                  usersData.status === 0 ? "bg-green-500" : "bg-red-500"
                }`}
              >
                {usersData.status === 0 ? t("admin_unblacklist") : t("admin_blacklist")}
              </button>
              <div
                onClick={() => {
                  handleAccessUser(usersData.id);
                }}
                className="w-32 rounded-lg bg-green-400 cursor-pointer
                 flex gap-2 items-center justify-center p-1 py-3 md:w-[49%] sm:w-[49%]"
              >
                <p className="text-white text-sm ">{t("admin_login_as")}</p>
              </div>
            </div>
          </div>
          <div className="pt-5 flex gap-5 md:flex-col md:gap-0 sm:flex-col sm:gap-0">
            {usersData.company_id === null ? (
              <>
                <div className="w-6/12 sm:w-full md:w-full">
                  <TextInput
                    name={t("admin_first_name")}
                    inputName={"fname"}
                    inputSetter={handleNewUsersData}
                    value={usersData.fname}
                  />
                  <TextInput
                    name={t("admin_last_name")}
                    inputName={"lname"}
                    inputSetter={handleNewUsersData}
                    value={usersData.lname}
                  />
                  <TextInput
                    name={t("admin_email")}
                    inputName={"email"}
                    inputSetter={handleNewUsersData}
                    value={usersData.email}
                  />
                  <TextInput
                    name={t("admin_personal_number")}
                    inputName={"person_id"}
                    inputSetter={handleNewUsersData}
                    value={usersData.person_id}
                  />
                </div>
                <div className="w-6/12 sm:w-full md:w-full">
                  <TextInput
                    name={t("admin_first_name_latin")}
                    inputName={"fname_eng"}
                    inputSetter={handleNewUsersData}
                    value={usersData.fname_eng}
                  />
                  <TextInput
                    name={t("admin_last_name_latin")}
                    inputName={"lname_eng"}
                    inputSetter={handleNewUsersData}
                    value={usersData.lname_eng}
                  />
                  <TextInput
                    name={t("admin_phone")}
                    inputName={"phone"}
                    inputSetter={handleNewUsersData}
                    value={usersData.phone}
                  />
                  <TextInput
                    name={t("password")}
                    inputName={"password"}
                    inputSetter={handleNewUsersData}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="w-6/12 sm:w-full md:w-full">
                  <TextInput
                    name={t("admin_first_name")}
                    inputName={"cname"}
                    inputSetter={handleNewUsersData}
                    value={usersData.cname}
                  />
                  <TextInput
                    name={t("admin_first_name_latin")}
                    inputName={"cname_eng"}
                    inputSetter={handleNewUsersData}
                    value={usersData.cname_eng}
                  />
                  <TextInput
                    name={t("admin_email")}
                    inputName={"email"}
                    inputSetter={handleNewUsersData}
                    value={usersData.email}
                  />
                </div>
                <div className="w-6/12 sm:w-full md:w-full">
                  <TextInput
                    name={t("admin_identification_code")}
                    inputName={"person_id"}
                    inputSetter={handleNewUsersData}
                    value={usersData.company_id}
                  />
                  <TextInput
                    name={t("admin_phone")}
                    inputName={"phone"}
                    inputSetter={handleNewUsersData}
                    value={usersData.phone}
                  />
                  <TextInput
                    name={t("password")}
                    inputName={"password"}
                    inputSetter={handleNewUsersData}
                  />
                </div>
              </>
            )}
          </div>
          <div className="w-full grid grid-cols-2 md:grid-cols-1 gap-5 md:gap-0">
            {user.role === "100" && (
              <TextInput
                name={t("admin_balance")}
                inputName={"balance"}
                inputSetter={handleNewUsersData}
                value={usersData.balance}
              />
            )}
            <TextInput
              name={t("admin_discount_percent")}
              inputName={"discount"}
              inputSetter={handleNewUsersData}
              value={usersData.discount}
            />
          </div>

          {/* Read-only view of the user's active promocode. Loaded eagerly on
              the admin user-detail endpoint so no extra request is needed.
              Admins edit promos in the promokodi section, not here. */}
          {usersData?.promokodi && (
            <div className="mt-3 rounded-xl border border-teal-100 bg-teal-50 p-3">
              <p className="text-xs font-bold text-teal-800 mb-1">
                {t("admin_current_promo") || "აქტიური პრომოკოდი"}
              </p>
              <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 text-sm">
                <span className="font-bold text-teal-900">
                  {usersData.promokodi.name}
                </span>
                <span className="text-teal-800">
                  {usersData.promokodi.percent}%
                </span>
                <span className="text-[11px] text-slate-600">
                  {(usersData.promokodi.date_from || "").slice(0, 10)} →{" "}
                  {(usersData.promokodi.date_to || "").slice(0, 10)}
                </span>
              </div>
            </div>
          )}

          {/* Delivery addresses. Parcels go to the door now, so an operator
              looking at a customer needs to see where — and, just as usefully,
              when there is no address at all, since those parcels can't be
              handed to a courier. */}
          <div className="mt-3 rounded-xl border border-slate-200 dark:border-slate-600 p-3">
            <p className="text-xs font-bold text-slate-600 dark:text-slate-300 mb-2">
              მიტანის მისამართები
              {usersData?.addresses ? ` (${usersData.addresses.length})` : ""}
            </p>

            {!usersData?.addresses?.length ? (
              <p className="text-xs text-red-600 bg-red-50 border border-red-200 rounded-lg p-2">
                მისამართი არ აქვს — ამანათი კურიერს ვერ გადაეცემა
              </p>
            ) : (
              <div className="flex flex-col gap-2">
                {usersData.addresses.map((a) => (
                  <div
                    key={a.id}
                    className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm
                               border-b border-slate-100 dark:border-slate-600 pb-2 last:border-0 last:pb-0"
                  >
                    <span className="font-bold dark:text-white">
                      {a.city}
                      {a.is_highland && (
                        <span
                          className="ml-1 text-[11px] text-amber-700 bg-amber-100 px-1.5 py-0.5 rounded-full"
                          title="მაღალმთიანი ზონა — ტარიფი მაღალია"
                        >
                          ⛰ მაღალმთიანი
                        </span>
                      )}
                    </span>
                    <span className="dark:text-slate-200">{a.address}</span>
                    <span className="text-slate-500 text-xs">
                      {a.phone || usersData.phone || "—"}
                    </span>
                    {a.is_default && (
                      <span className="text-[11px] text-teal-800 bg-teal-100 px-1.5 py-0.5 rounded-full font-bold">
                        ★ მთავარი
                      </span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

    </div>
  );
};

export default InnerUsPage;
